import { render, staticRenderFns } from "./VerifyComponent.vue?vue&type=template&id=33ca4b57&lang=pug&"
import script from "./VerifyComponent.vue?vue&type=script&lang=js&"
export * from "./VerifyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports